import httpClient from '@/http-client'

export const get = (Options = {}) => {
    return httpClient
      .get('/api/v1/promotion-lists', Options)
      .then(response => Promise.resolve(response.data))
      .catch(error => Promise.reject(error.response.data))
}

export const getBranch = (Options = {}) => {
    return httpClient
    .get('/api/v1/discounts/branches', Options)
    .then(response => Promise.resolve(response.data))
    .catch(error => Promise.reject(error.response.data)) 
}

export const getSaleCode = (Options = {}) => {
    return httpClient
    .get('/api/v1/discounts/product-salecodes', Options)
    .then(response => Promise.resolve(response.data))
    .catch(error => Promise.reject(error.response.data)) 
}

export default { getBranch, getSaleCode, get }